angular
  .module('capability-ng-scheduler')
  .service(
    'loadSuggestionsCommand',
    function loadSuggestionsCommandDefinition($http, defineCommand, SuggestionsBuilder) {
      'use strict';

      return defineCommand('loadSuggestionsCommand', function loadSuggestionsCommand(deferred, termId) {
        $http
          .get('/reg/scheduler/term/' + termId + '/')
          .then(function (response) {
            deferred.resolve(new SuggestionsBuilder(response.data));
          })
          .catch(function (e) {
            log.issue('failed to load term information');
            deferred.reject();
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/modals/suggestions/commands/load_suggestions_command.js